import React, { useState, useCallback } from 'react';
import propTypes from 'prop-types';

import { FloorPlanPropTypes } from '../../utils/DrupalEntityTypes/FloorPlan/FloorPlanPropTypes';
import FloorPlansPageListItem from './FloorPlansPageListItem';

import '../../GlobalScss/grid.scss';

const FloorPlansPageList = ( { items, showSoldOutStatus, showAvailableUnits } ) => {
  // Track a single open inventory dropdown so opening one closes the other.
  const [ openInventoryUuid, setOpenInventoryUuid ] = useState( null );

  const handleToggleInventory = useCallback( ( uuid ) => {
    setOpenInventoryUuid( ( current ) => ( current === uuid ? null : uuid ) );
  }, [] );

  return (
    <div className="gridContainer">
      { items?.map( ( item, index ) => (
        <FloorPlansPageListItem
          key={item?.uuid}
          data={item}
          index={index}
          showSoldOutStatus={showSoldOutStatus}
          showAvailableUnits={showAvailableUnits}
          isInventoryOpen={openInventoryUuid === item?.uuid}
          onToggleInventory={handleToggleInventory}
        />
      ) ) }
    </div>
  );
};

FloorPlansPageList.propTypes = {
  items: propTypes.arrayOf( propTypes.shape( {
    data: FloorPlanPropTypes.data,
  } ) ),
  showSoldOutStatus: propTypes.bool,
  showAvailableUnits: propTypes.bool,
};

FloorPlansPageList.defaultProps = {
  items: [],
  showSoldOutStatus: false,
  showAvailableUnits: false,
};

export default FloorPlansPageList;
